// extracted by mini-css-extract-plugin
export default {"skeletonLoader":"GtV_eV","skeletonCircle":"mRL2jH","skeletonText":"m7Xfv9","long":"EdyW4X","short":"h4x6kd","skeletonAnimator":"KkeySC","slide":"bD7PCX"};